import { useLocation } from "react-router-dom";
import BookingFloorMap from "./BookingFloorMap";

export function BookingFloorMapWithKey() {
  const location = useLocation();
  const key = location.pathname + JSON.stringify(location.state || {});

  return <BookingFloorMap key={key} />;
}